
// 封装oss方法
import OSS from 'ali-oss';
// 实例化OSS，并配置OSS信息
export const client = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAI5t7jj78F1J8ijGpS4sbo',
    accessKeySecret: 'sCVzdSVLJBS0cZb8y2pvBWXa1Hfy4K',
    endpoint: "oss-cn-beijing.aliyuncs.com",
    bucket: 'ycawxmp',
}); 
// 分片配置项
export const options = {
  // 设置并发上传的分片数量。
  parallel: 4,
  // 设置分片大小。默认值为1 MB，最小值为100 KB。
  partSize: 1024 * 1024,
  // 设置请求头
  headers: {
    // 指定该Object被下载时的内容编码格式。
    "Content-Encoding": "utf-8",
    // 指定过期时间，单位为毫秒。
    Expires: "1000",
    // 指定Object的存储类型。
    "x-oss-storage-class": "Standard",
    // 指定Object标签，可同时设置多个标签。
    "x-oss-tagging": "Tag1=1&Tag2=2",
    // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
    "x-oss-forbid-overwrite": "false",
  },
  // 指定上传文件类型
  mime: "text/plain",
};